// extracted by mini-css-extract-plugin
module.exports = {"container_s":"styles_container_s__jxGTw","container_reviews":"styles_container_reviews__2rj3r","reviews__row":"styles_reviews__row__gILDb"};